import { isPlatformBrowser } from '@angular/common';
import { AfterViewInit, Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { NgbCarouselModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { loadComponentTranslations } from '../../funcs/lang-loader';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-testimonials',
  imports: [NgbCarouselModule, TranslateModule],
  templateUrl: './testimonials.component.html',
  styleUrl: './testimonials.component.scss'
})
export class TestimonialsComponent implements OnInit {
  testimonials: any = [

  ];

  constructor(
    private _translateService: TranslateService,
    private _http: HttpClient,
    @Inject(PLATFORM_ID) private platformId: Object,

  ) {

  }

  private isBrowser(): boolean {
    return isPlatformBrowser(this.platformId);
  }

  public ngOnInit(): void {

    let lang = this._translateService.currentLang || 'en';

    this._http.get<any>('./assets/i18n/static-content/testimonials.json')
      .subscribe({
        next: res => {
          this.testimonials = res[lang]?.['testimonials'];
        }
      });


    loadComponentTranslations(this._http, this._translateService, 'controls/testimonials', this.isBrowser())
      .subscribe({
        next: () => {

        },
        error: () => {

        }
      });
  }


}
